import React, { createContext, useContext, useState, useEffect } from "react";

/* ═══════════════════════════════════════════════════════════════════
   i18n — 22 языков (RU по умолчанию)
   Translations live in ./locales/{code}.json (generated via Claude
   Haiku 4.5 from /app/scripts/gen_i18n.py — see source RU dictionary).
═══════════════════════════════════════════════════════════════════ */

// All 22 languages bundled at build time via webpack require.context-equivalent
import ru from "./locales/ru.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import kk from "./locales/kk.json";
import zh from "./locales/zh.json";
import ar from "./locales/ar.json";
import hi from "./locales/hi.json";
import pt from "./locales/pt.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import tr from "./locales/tr.json";
import uz from "./locales/uz.json";
import uk from "./locales/uk.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";
import fa from "./locales/fa.json";
import id from "./locales/id.json";
import th from "./locales/th.json";
import vi from "./locales/vi.json";
import nl from "./locales/nl.json";
import pl from "./locales/pl.json";

export const LANGUAGES = [
  { code: "ru", flag: "🇷🇺", name: "Русский" },
  { code: "en", flag: "🇺🇸", name: "English" },
  { code: "de", flag: "🇩🇪", name: "Deutsch" },
  { code: "kk", flag: "🇰🇿", name: "Қазақша" },
  { code: "zh", flag: "🇨🇳", name: "中文" },
  { code: "ar", flag: "🇸🇦", name: "العربية" },
  { code: "hi", flag: "🇮🇳", name: "हिन्दी" },
  { code: "pt", flag: "🇵🇹", name: "Português" },
  { code: "fr", flag: "🇫🇷", name: "Français" },
  { code: "es", flag: "🇪🇸", name: "Español" },
  { code: "it", flag: "🇮🇹", name: "Italiano" },
  { code: "tr", flag: "🇹🇷", name: "Türkçe" },
  { code: "uz", flag: "🇺🇿", name: "Oʻzbek" },
  { code: "uk", flag: "🇺🇦", name: "Українська" },
  { code: "ja", flag: "🇯🇵", name: "日本語" },
  { code: "ko", flag: "🇰🇷", name: "한국어" },
  { code: "fa", flag: "🇮🇷", name: "فارسی" },
  { code: "id", flag: "🇮🇩", name: "Indonesia" },
  { code: "th", flag: "🇹🇭", name: "ไทย" },
  { code: "vi", flag: "🇻🇳", name: "Tiếng Việt" },
  { code: "nl", flag: "🇳🇱", name: "Nederlands" },
  { code: "pl", flag: "🇵🇱", name: "Polski" },
];

const DICT = { ru, en, de, kk, zh, ar, hi, pt, fr, es, it, tr, uz, uk, ja, ko, fa, id, th, vi, nl, pl };

const I18nCtx = createContext({ lang: "ru", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("tg_lang") || "ru");
  const setLang = (code) => {
    setLangState(code);
    localStorage.setItem("tg_lang", code);
    const isRtl = ["ar", "fa"].includes(code);
    document.documentElement.setAttribute("dir", isRtl ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", code);
  };
  useEffect(() => {
    const isRtl = ["ar", "fa"].includes(lang);
    document.documentElement.setAttribute("dir", isRtl ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", lang);
  }, []); // eslint-disable-line
  const t = (key) => (DICT[lang] && DICT[lang][key]) || DICT.ru[key] || key;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}
export const useT = () => useContext(I18nCtx);
